<template>
    <list-page icone="mdi-calendar-cursor" titulo="Indicador" @novo="Novo()" @atualizar="Carregar()" :temBuscaRapida="true" :buscaRapida.sync="search" :botaoPadrao="false">
        
        <template v-slot:botoes>
          <v-btn color="click" class="mb-2" @click="Novo()" style="margin-top: 10px">
            <v-icon style="color: white">mdi-plus</v-icon>
            <span style="color: white">Novo Relatório</span>
          </v-btn>
          
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="click" class="mb-2" v-on="on" @click="Carregar()" style="margin-top: 10px">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Atualizar</span>
          </v-tooltip>

        </template>
        
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

            <template v-slot:[`item.data`]="{ item }">
              {{new Date(item.data).ddmmyyyy()}}
            </template>

          </v-data-table>

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-monitoramento-indicador v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Carregar()"/>
          
        </template>
    </list-page>
</template>

<script>
import ListPage from "@/components/shared/ListPage";
import { MonitoramentoIndicadorService } from "@/core/services/projetos/monitoramento"
import { MonitoramentoIndicador } from "@/core/domain/projetos/monitoramento"

export default {
  extends: ListPage,
    watch: { 
      item: function() { 
        if ('formAtividade' in this.$refs)
          this.$refs.formAtividade.resetValidation();        
      },
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    data: () => ({
      headers: [
        { text: '', value: 'actions', sortable: false},
        { text: 'Projeto', value: 'projeto.nome' },
        { text: 'Data', value: 'data', type:'date' }
      ],
      primeiraCarga: true
    }),
    created() {
      this.service = new MonitoramentoIndicadorService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new MonitoramentoIndicador());
      },
      Editar(item){
        this.service.ObterPorId(item.id, "Projeto, Itens").then(
          res =>{
            this.EditarCadastro(new MonitoramentoIndicador(res.data));
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
      },
      Carregar(){
        this.include = "Projeto"
        this.Listar(null, "Projeto")
      }
    },
    mounted() {
      this.Carregar()
    }
}

</script>